import { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../../helper/api';

const TransferCashToBank = ({ token }) => {
    const [amount, setAmount] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!amount || amount <= 0) {
            alert('Masukkan jumlah transfer yang valid');
            return;
        }

        setIsLoading(true);
        
        try {
            await axios.post(`${API_URL}/cash-to-bank?token=${token}`, { amount });
            alert('✅ Transfer berhasil!');
            setAmount('');
        } catch (error) {
            console.error('Transfer error:', error);
            alert('❌ Terjadi kesalahan jaringan');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="w-full max-w-md">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
                <div className="text-center mb-8">
                    <h2 className="text-2xl font-semibold text-gray-900 mb-2">
                        Transfer Cash
                    </h2>
                    <p className="text-gray-500 text-sm">ke BCA</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="transfer-amount" className="block text-sm font-medium text-gray-700 mb-2">
                            Jumlah Transfer
                        </label>
                        <div className="relative">
                            <span className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">
                                Rp
                            </span>
                            <input
                                id="transfer-amount"
                                type="number"
                                placeholder="0"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                required
                                min="1"
                                className="w-full pl-10 pr-4 py-4 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-lg placeholder-gray-400"
                            />
                        </div>
                    </div>

                    <button
                        type="submit"
                        disabled={isLoading}
                        className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white font-semibold py-4 px-6 rounded-xl transition-colors duration-200 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none"
                    >
                        {isLoading ? 'Memproses...' : 'Transfer Sekarang'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default TransferCashToBank; 